import UdeskLocales from 'UdeskLocales';
import React, { useCallback } from 'react';
import { Button, Dropdown, Icon, Modal } from 'udesk-ui';

const SettingMenu = (props) => {
    const { reverse, recover, reAsr, reTranslate, isRelated, placement = 'bottomRight' } = props;

    const locales = UdeskLocales['current'];

    const modalCallback = useCallback((callback, title) => {
        return () => {
            Modal.confirm({
                title: title,
                onOk: callback,
            });
        };
    }, []);

    const reverseCallback = useCallback(modalCallback(reverse, locales.fix.sureReRole), [reverse]);
    const recoverCallback = useCallback(modalCallback(recover, locales.fix.sureRecover), [recover]);
    const reAsrCallback = useCallback(modalCallback(reAsr, locales.fix.sureReAsr), [reAsr]);
    const reTranslateCallback = useCallback(
        modalCallback(
            reTranslate,
            /* 确认重新翻译吗？ */ UdeskLocales['current'].components.waveAudioTalk.template
                .confirmRetranslation
        ),
        [reTranslate]
    );

    return (
        <Dropdown
            overlay={
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#fff' }}>
                    {!isRelated && reverse && (
                        <Button type="text" onClick={reverseCallback}>
                            {locales.fix.reRole}
                        </Button>
                    )}

                    {recover && (
                        <Button type="text" onClick={recoverCallback}>
                            {locales.fix.recover}
                        </Button>
                    )}

                    {reAsr && (
                        <Button type="text" onClick={reAsrCallback}>
                            {locales.fix.reAsr}
                        </Button>
                    )}

                    {reTranslate && (
                        <Button type="text" onClick={reTranslateCallback}>
                            {/* 重新翻译 */}
                            {
                                UdeskLocales['current'].components.waveAudioTalk.template
                                    .retranslation
                            }
                        </Button>
                    )}
                </div>
            }
            placement={placement}
        >
            <Icon type="ic-set-shezhi1" style={{ fontSize: '16px' }} />
        </Dropdown>
    );
};

export default SettingMenu;
